import { computed } from "vue";
import { useUIContent } from "../../configuration/useUIContent";
import { standard, pensionIncreaseExchange, bridgingPension, FinalSalaryOptionsStatic } from "./finalSalaryOptionInfoStatic";

export function useFinalSalaryStaticOptions() {
    const { text, textArray } = useUIContent();

    const finalSalaryOptionsStatic = computed<FinalSalaryOptionsStatic>(() => {
        standard.name = text("terminology.final-salary-options.standard.name") || standard.name;
        standard.description = textArray("dboptions.options.standard.summary");

        bridgingPension.description = textArray("dboptions.options.bridging-pension.summary");

        pensionIncreaseExchange.description = textArray("dboptions.options.pie.summary");

        return new FinalSalaryOptionsStatic(standard, pensionIncreaseExchange, bridgingPension);
    });

    return {
        finalSalaryOptionsStatic
    };
}
